import Backbone from 'backbone';

export default Backbone.Model.extend({
    defaults: {
        account_id     : 0,
        oauth_token_id : 0,
        app_type       : '',
        app_host       : '',
        custom_name    : '',
        create_time    : 0,
        creator_id     : 0,
        access_token   : '',
        refresh_token  : '',
        expires_at     : 0,
        is_disabled    : false,
        fail_count     : 0
    },

    isDisabled: function() {
        var now = (new Date()).getTime() / 1000;
        var is_expired = this.get('is_disabled') || (this.get('expires_at') > 0 && this.get('expires_at') < now);

        return is_expired;
    }
});